import { CheckCircle2, Circle, History } from "lucide-react";
import { dateBR, dateTimeBR } from "../../lib/format";
import { WHO } from "./ReviewParts";

const Row = ({ k, v, testid }) => <div><div className="text-[11px] uppercase tracking-wide text-slate-400">{k}</div><div className="text-sm font-medium" data-testid={testid}>{v || "—"}</div></div>;

export function AdmissionSummary({ v }) {
  return (
    <div className="mt-3 space-y-3 rounded-lg border bg-slate-50/60 p-3" data-testid="review-summary">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Row k="Funcionário" v={v.employee.name} testid="review-sum-name" />
        <Row k="Empresa contratante" v={v.company?.legal_name || v.company?.trade_name} testid="review-sum-company" />
        <Row k="Data prevista de admissão" v={v.admission_date && dateBR(v.admission_date)} testid="review-sum-date" />
        <Row k="Responsável pela próxima ação" v={v.actor ? WHO[v.actor] : "Nenhuma ação pendente"} testid="review-sum-actor" />
      </div>
      <div data-testid="review-sum-pending"><div className="text-[11px] uppercase tracking-wide text-slate-400">Pendências</div>
        {!v.pending.length ? <div className="text-sm text-slate-600">Nenhuma pendência nesta etapa.</div>
          : <ul className="list-disc pl-5 text-sm">{v.pending.map((p) => <li key={p.key}>{p.label} · {WHO[p.owner]}</li>)}</ul>}</div>
      <div data-testid="review-sum-docs"><div className="text-[11px] uppercase tracking-wide text-slate-400">Documentos recebidos e pendentes</div>
        <div className="mt-1 grid gap-1 sm:grid-cols-2">{v.docs_status.map((x) => (
          <div key={x.key} className={`flex items-center gap-1.5 text-sm ${x.received ? "text-emerald-700" : x.required ? "text-amber-700" : "text-slate-500"}`} data-testid={`review-doc-status-${x.key}`} data-received={x.received ? "true" : "false"}>
            {x.received ? <CheckCircle2 className="h-4 w-4" /> : <Circle className="h-4 w-4" />}{x.label}{!x.received && (x.required ? " · pendente" : " · opcional")}</div>))}</div></div>
    </div>);
}

export function AdmissionHistory({ items }) {
  return (
    <ol className="space-y-2 border-l pl-4" data-testid="review-history">
      {!items.length && <li className="text-sm text-slate-500">Sem movimentações registradas.</li>}
      {items.map((h, i) => (
        <li key={i} className="relative text-sm" data-testid={`review-history-${i}`}>
          <History className="absolute -left-[23px] top-0.5 h-3.5 w-3.5 bg-white text-slate-400" />
          <div className="font-medium">{h.text}</div>
          <div className="text-xs text-slate-500">{dateTimeBR(h.at)} · {h.by}{h.detail ? ` · ${h.detail}` : ""}</div>
        </li>))}
    </ol>);
}
